module.exports = __webpack_public_path__ + "img/menu_user.f112db0a.svg";